"use strict";
/*
 * ULAD enums defined here:
 * https://docs.google.com/spreadsheets/d/13ppjfs8hs_SOgLMCHfwMcDRbL7CDtRCpv_3QR4xjLaU/edit?gid=770637105#gid=770637105
 *
 * Commented values are not used but defined in the ULAD spec
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mismo34CreditScoreCategoryType = exports.Mismo34CreditRepositorySourceType = exports.Mismo34HmdaApplicationTakenType = exports.Mismo34HmdaRaceDesignationType = exports.Mismo34HmdaRaceType = exports.Mismo34HmdaGenderType = exports.Mismo34HmdaEthnicityOriginType = exports.Mismo34HmdaEthnicityType = exports.Mismo34BankruptcyType = exports.Mismo34DeclarationPriorPropertyTitleType = exports.Mismo34DeclarationYesNoUnknown = exports.Mismo34RealEstateLiabilityType = exports.Mismo34NonRealEstateLiabilityType = exports.Mismo34ExpenseType = exports.ACCEPTABLE_OTHER_ASSET_TYPES = exports.Mismo34GiftOrGrantFundsSourceType = exports.Mismo34GiftOrGrantAssetType = exports.Mismo34OtherOtherAssetType = exports.Mismo34OtherAssetType = exports.Mismo34FinancialAccountAssetType = exports.Mismo34AssetType = exports.Mismo34AssetAccountType = exports.Mismo34PropertyIntendedUsageType = exports.Mismo34PropertyCurrentUsageType = exports.Mismo34OwnedPropertyDispositionStatusType = exports.Mismo34OtherIncomeType = exports.Mismo34EmploymentIncomeType = exports.Mismo34EmploymentClassificationType = exports.Mismo34EmploymentOwnershipInterestType = exports.Mismo34EmploymentStatusType = exports.Mismo34AddressType = exports.Mismo34BorrowerResidencyBasisType = exports.Mismo34BorrowerResidencyType = exports.Mismo34IntegratedDisclosureSectionType = exports.Mismo34FeePercentBasisType = exports.Mismo34FeePaidToType = exports.Mismo34FeeType = exports.Mismo34AmortizationType = exports.Mismo34LoanAmortizationPeriodType = exports.Mismo34LienPriorityType = exports.Mismo34MortgageType = exports.Mismo34MortgageTypeOtherDescription = exports.Mismo34LoanPurposeOtherDescription = exports.Mismo34LoanPurposeType = exports.Mismo34RefinancePrimaryPurposeType = exports.Mismo34RefinanceCashOutDeterminationType = exports.Mismo34CurrentFirstMortgageHolderType = exports.Mismo34EscrowAccountLenderRequirementType = exports.Mismo34LoanIdentifierType = exports.Mismo34LoanRoleType = void 0;
exports.Mismo34RelationshipArcrole = exports.Mismo34CitizenshipResidencyType = exports.Mismo34ContactPointRoleType = exports.Mismo34MaritalStatusType = exports.Mismo34TaxpayerIdentifierType = exports.Mismo34LicenseAuthorityLevelType = exports.Mismo34LoanOriginatorType = exports.Mismo34PartyRoleType = void 0;
/* ========== End of Common ========== */
/* ========== Start of Loan ========== */
// An attribute of LOAN used to identify the role the associated LOAN plays in the transaction.
var Mismo34LoanRoleType;
(function (Mismo34LoanRoleType) {
    Mismo34LoanRoleType["SubjectLoan"] = "SubjectLoan";
    // RelatedLoan = 'RelatedLoan',
})(Mismo34LoanRoleType || (exports.Mismo34LoanRoleType = Mismo34LoanRoleType = {}));
// A value from a MISMO prescribed list that specifies the type of loan identifier.
var Mismo34LoanIdentifierType;
(function (Mismo34LoanIdentifierType) {
    Mismo34LoanIdentifierType["LenderLoan"] = "LenderLoan";
    Mismo34LoanIdentifierType["UniversalLoan"] = "UniversalLoan";
})(Mismo34LoanIdentifierType || (exports.Mismo34LoanIdentifierType = Mismo34LoanIdentifierType = {}));
// A value from a MISMO prescribed list that specifies whether the lender requires an escrow/impound account.
var Mismo34EscrowAccountLenderRequirementType;
(function (Mismo34EscrowAccountLenderRequirementType) {
    Mismo34EscrowAccountLenderRequirementType["EscrowsRequiredByLender"] = "EscrowsRequiredByLender";
    Mismo34EscrowAccountLenderRequirementType["EscrowsWaivedByLender"] = "EscrowsWaivedByLender";
})(Mismo34EscrowAccountLenderRequirementType || (exports.Mismo34EscrowAccountLenderRequirementType = Mismo34EscrowAccountLenderRequirementType = {}));
// Specifies the investor holding the first mortgage that is being refinanced.
var Mismo34CurrentFirstMortgageHolderType;
(function (Mismo34CurrentFirstMortgageHolderType) {
    // Fannie Mae
    Mismo34CurrentFirstMortgageHolderType["FNM"] = "FNM";
})(Mismo34CurrentFirstMortgageHolderType || (exports.Mismo34CurrentFirstMortgageHolderType = Mismo34CurrentFirstMortgageHolderType = {}));
// A value from a MISMO prescribed list that classifies a refinanced loan.
var Mismo34RefinanceCashOutDeterminationType;
(function (Mismo34RefinanceCashOutDeterminationType) {
    Mismo34RefinanceCashOutDeterminationType["CashOut"] = "CashOut";
    Mismo34RefinanceCashOutDeterminationType["LimitedCashOut"] = "LimitedCashOut";
    Mismo34RefinanceCashOutDeterminationType["NoCashOut"] = "NoCashOut";
})(Mismo34RefinanceCashOutDeterminationType || (exports.Mismo34RefinanceCashOutDeterminationType = Mismo34RefinanceCashOutDeterminationType = {}));
// Specifies the primary purpose of the refinance.
var Mismo34RefinancePrimaryPurposeType;
(function (Mismo34RefinancePrimaryPurposeType) {
    Mismo34RefinancePrimaryPurposeType["DebtConsolidation"] = "DebtConsolidation";
    Mismo34RefinancePrimaryPurposeType["HomeImprovement"] = "HomeImprovement";
    Mismo34RefinancePrimaryPurposeType["Other"] = "Other";
})(Mismo34RefinancePrimaryPurposeType || (exports.Mismo34RefinancePrimaryPurposeType = Mismo34RefinancePrimaryPurposeType = {}));
// Specifies the purpose for which the loan proceeds will be used.
var Mismo34LoanPurposeType;
(function (Mismo34LoanPurposeType) {
    Mismo34LoanPurposeType["Purchase"] = "Purchase";
    Mismo34LoanPurposeType["Refinance"] = "Refinance";
    // ULAD/MISMO has no dedicated HELOC purpose; an open-end home-equity line is modeled as
    // `Other` + a `LoanPurposeTypeOtherDescription` of "HELOC" (see Mismo34LoanPurposeOtherDescription).
    Mismo34LoanPurposeType["Other"] = "Other";
})(Mismo34LoanPurposeType || (exports.Mismo34LoanPurposeType = Mismo34LoanPurposeType = {}));
// Free-form description used when LoanPurposeType is Other. Constrained to an enum so the HELOC
// description string is greppable and consistent across every emitted document.
/** @TranslateToPython */
var Mismo34LoanPurposeOtherDescription;
(function (Mismo34LoanPurposeOtherDescription) {
    Mismo34LoanPurposeOtherDescription["HELOC"] = "HELOC";
    Mismo34LoanPurposeOtherDescription["CASH_OUT"] = "CashOut";
})(Mismo34LoanPurposeOtherDescription || (exports.Mismo34LoanPurposeOtherDescription = Mismo34LoanPurposeOtherDescription = {}));
// Free-form description used when MortgageType is Other. An Aven HELOC is modeled as MortgageType
// Other + description "HELOC".
var Mismo34MortgageTypeOtherDescription;
(function (Mismo34MortgageTypeOtherDescription) {
    Mismo34MortgageTypeOtherDescription["HELOC"] = "HELOC";
})(Mismo34MortgageTypeOtherDescription || (exports.Mismo34MortgageTypeOtherDescription = Mismo34MortgageTypeOtherDescription = {}));
// A value from a MISMO prescribed list that specifies the private or public sector entity under whose guidelines the mortgage is originated.
var Mismo34MortgageType;
(function (Mismo34MortgageType) {
    Mismo34MortgageType["Conventional"] = "Conventional";
    Mismo34MortgageType["Other"] = "Other";
    // FHA = 'FHA',
    // USDARuralDevelopment = 'USDARuralDevelopment',
    // VA = 'VA',
})(Mismo34MortgageType || (exports.Mismo34MortgageType = Mismo34MortgageType = {}));
// A value from a MISMO prescribed list that specifies the priority of the lien against the subject property.
var Mismo34LienPriorityType;
(function (Mismo34LienPriorityType) {
    Mismo34LienPriorityType["FirstLien"] = "FirstLien";
    Mismo34LienPriorityType["SecondLien"] = "SecondLien";
    Mismo34LienPriorityType["ThirdLien"] = "ThirdLien";
    Mismo34LienPriorityType["FourthLien"] = "FourthLien";
    Mismo34LienPriorityType["Other"] = "Other";
})(Mismo34LienPriorityType || (exports.Mismo34LienPriorityType = Mismo34LienPriorityType = {}));
// The duration of time used to define the period over which the loan is amortized.
var Mismo34LoanAmortizationPeriodType;
(function (Mismo34LoanAmortizationPeriodType) {
    Mismo34LoanAmortizationPeriodType["Month"] = "Month";
})(Mismo34LoanAmortizationPeriodType || (exports.Mismo34LoanAmortizationPeriodType = Mismo34LoanAmortizationPeriodType = {}));
// A classification or description of a loan or a group of loans generally based on the changeability of the rate or payment over time.
// For subject mortgage loan, cannot be "PotentialNegativeAmortization" nor "ScheduledNegativeAmortization"
var Mismo34AmortizationType;
(function (Mismo34AmortizationType) {
    // GEM = 'GEM',
    // GPM = 'GPM',
    Mismo34AmortizationType["AdjustableRate"] = "AdjustableRate";
    Mismo34AmortizationType["Fixed"] = "Fixed";
    // PotentialNegativeAmortization = 'PotentialNegativeAmortization',
    // ScheduledNegativeAmortization = 'ScheduledNegativeAmortization',
    // Other = 'Other',
})(Mismo34AmortizationType || (exports.Mismo34AmortizationType = Mismo34AmortizationType = {}));
// A value from a MISMO prescribed list identifying the type of fee.
var Mismo34FeeType;
(function (Mismo34FeeType) {
    Mismo34FeeType["LoanOriginationFee"] = "LoanOriginationFee";
    Mismo34FeeType["RecordingFeeTotal"] = "RecordingFeeTotal";
    Mismo34FeeType["Other"] = "Other";
})(Mismo34FeeType || (exports.Mismo34FeeType = Mismo34FeeType = {}));
// A value from a MISMO prescribed list identifying the party a fee is paid to.
var Mismo34FeePaidToType;
(function (Mismo34FeePaidToType) {
    Mismo34FeePaidToType["Lender"] = "Lender";
    Mismo34FeePaidToType["Other"] = "Other";
})(Mismo34FeePaidToType || (exports.Mismo34FeePaidToType = Mismo34FeePaidToType = {}));
// The base against which a fee's percent is applied.
var Mismo34FeePercentBasisType;
(function (Mismo34FeePercentBasisType) {
    Mismo34FeePercentBasisType["BaseLoanAmount"] = "BaseLoanAmount";
})(Mismo34FeePercentBasisType || (exports.Mismo34FeePercentBasisType = Mismo34FeePercentBasisType = {}));
// The section of the integrated disclosure (LE/CD) a fee is disclosed under.
var Mismo34IntegratedDisclosureSectionType;
(function (Mismo34IntegratedDisclosureSectionType) {
    Mismo34IntegratedDisclosureSectionType["OriginationCharges"] = "OriginationCharges";
    // TRID Section E — recording fees and recording/transfer taxes.
    Mismo34IntegratedDisclosureSectionType["TaxesAndOtherGovernmentFees"] = "TaxesAndOtherGovernmentFees";
})(Mismo34IntegratedDisclosureSectionType || (exports.Mismo34IntegratedDisclosureSectionType = Mismo34IntegratedDisclosureSectionType = {}));
/* ========== End of Loan ========== */
/* ========== Start of Address History ========== */
var Mismo34BorrowerResidencyType;
(function (Mismo34BorrowerResidencyType) {
    Mismo34BorrowerResidencyType["Current"] = "Current";
    Mismo34BorrowerResidencyType["Prior"] = "Prior";
})(Mismo34BorrowerResidencyType || (exports.Mismo34BorrowerResidencyType = Mismo34BorrowerResidencyType = {}));
var Mismo34BorrowerResidencyBasisType;
(function (Mismo34BorrowerResidencyBasisType) {
    Mismo34BorrowerResidencyBasisType["LivingRentFree"] = "LivingRentFree";
    Mismo34BorrowerResidencyBasisType["Own"] = "Own";
    Mismo34BorrowerResidencyBasisType["Rent"] = "Rent";
})(Mismo34BorrowerResidencyBasisType || (exports.Mismo34BorrowerResidencyBasisType = Mismo34BorrowerResidencyBasisType = {}));
// A value from a MISMO prescribed list that specifies the type of address.
var Mismo34AddressType;
(function (Mismo34AddressType) {
    Mismo34AddressType["Current"] = "Current";
    Mismo34AddressType["Mailing"] = "Mailing";
    Mismo34AddressType["Primary"] = "Primary";
})(Mismo34AddressType || (exports.Mismo34AddressType = Mismo34AddressType = {}));
/* ========== End of Address History ========== */
/* ========== Start of Employment History ========== */
var Mismo34EmploymentStatusType;
(function (Mismo34EmploymentStatusType) {
    Mismo34EmploymentStatusType["Current"] = "Current";
    Mismo34EmploymentStatusType["Previous"] = "Previous";
})(Mismo34EmploymentStatusType || (exports.Mismo34EmploymentStatusType = Mismo34EmploymentStatusType = {}));
var Mismo34EmploymentOwnershipInterestType;
(function (Mismo34EmploymentOwnershipInterestType) {
    Mismo34EmploymentOwnershipInterestType["GreaterThanOrEqualTo25Percent"] = "GreaterThanOrEqualTo25Percent";
    Mismo34EmploymentOwnershipInterestType["LessThan25Percent"] = "LessThan25Percent";
})(Mismo34EmploymentOwnershipInterestType || (exports.Mismo34EmploymentOwnershipInterestType = Mismo34EmploymentOwnershipInterestType = {}));
var Mismo34EmploymentClassificationType;
(function (Mismo34EmploymentClassificationType) {
    Mismo34EmploymentClassificationType["Primary"] = "Primary";
    Mismo34EmploymentClassificationType["Secondary"] = "Secondary";
})(Mismo34EmploymentClassificationType || (exports.Mismo34EmploymentClassificationType = Mismo34EmploymentClassificationType = {}));
/* ========== End of Employment History ========== */
/* ========== Start of Income Item ========== */
var Mismo34EmploymentIncomeType;
(function (Mismo34EmploymentIncomeType) {
    /* Employment income */
    Mismo34EmploymentIncomeType["Base"] = "Base";
    Mismo34EmploymentIncomeType["Bonus"] = "Bonus";
    Mismo34EmploymentIncomeType["Commissions"] = "Commissions";
    Mismo34EmploymentIncomeType["ContractBasis"] = "ContractBasis";
    Mismo34EmploymentIncomeType["MilitaryBasePay"] = "MilitaryBasePay";
    Mismo34EmploymentIncomeType["MilitaryClothesAllowance"] = "MilitaryClothesAllowance";
    Mismo34EmploymentIncomeType["MilitaryCombatPay"] = "MilitaryCombatPay";
    Mismo34EmploymentIncomeType["MilitaryFlightPay"] = "MilitaryFlightPay";
    Mismo34EmploymentIncomeType["MilitaryHazardPay"] = "MilitaryHazardPay";
    Mismo34EmploymentIncomeType["MilitaryOverseasPay"] = "MilitaryOverseasPay";
    Mismo34EmploymentIncomeType["MilitaryPropPay"] = "MilitaryPropPay";
    Mismo34EmploymentIncomeType["MilitaryQuartersAllowance"] = "MilitaryQuartersAllowance";
    Mismo34EmploymentIncomeType["MilitaryRationsAllowance"] = "MilitaryRationsAllowance";
    Mismo34EmploymentIncomeType["MilitaryVariableHousingAllowance"] = "MilitaryVariableHousingAllowance";
    Mismo34EmploymentIncomeType["Overtime"] = "Overtime";
    Mismo34EmploymentIncomeType["Other"] = "Other";
})(Mismo34EmploymentIncomeType || (exports.Mismo34EmploymentIncomeType = Mismo34EmploymentIncomeType = {}));
var Mismo34OtherIncomeType;
(function (Mismo34OtherIncomeType) {
    /* Other sources of income */
    Mismo34OtherIncomeType["AccessoryUnitIncome"] = "AccessoryUnitIncome";
    Mismo34OtherIncomeType["Alimony"] = "Alimony";
    Mismo34OtherIncomeType["AutomobileAllowance"] = "AutomobileAllowance";
    Mismo34OtherIncomeType["BoarderIncome"] = "BoarderIncome";
    Mismo34OtherIncomeType["CapitalGains"] = "CapitalGains";
    Mismo34OtherIncomeType["ChildSupport"] = "ChildSupport";
    Mismo34OtherIncomeType["DefinedContributionPlan"] = "DefinedContributionPlan";
    Mismo34OtherIncomeType["Disability"] = "Disability";
    Mismo34OtherIncomeType["DividendsInterest"] = "DividendsInterest";
    Mismo34OtherIncomeType["EmploymentRelatedAccount"] = "EmploymentRelatedAccount";
    Mismo34OtherIncomeType["FosterCare"] = "FosterCare";
    Mismo34OtherIncomeType["HousingAllowance"] = "HousingAllowance";
    Mismo34OtherIncomeType["HousingChoiceVoucherProgram"] = "HousingChoiceVoucherProgram";
    Mismo34OtherIncomeType["MortgageCreditCertificate"] = "MortgageCreditCertificate";
    Mismo34OtherIncomeType["MortgageDifferential"] = "MortgageDifferential";
    Mismo34OtherIncomeType["NonBorrowerHouseholdIncome"] = "NonBorrowerHouseholdIncome";
    Mismo34OtherIncomeType["NotesReceivableInstallment"] = "NotesReceivableInstallment";
    Mismo34OtherIncomeType["Pension"] = "Pension";
    Mismo34OtherIncomeType["PublicAssistance"] = "PublicAssistance";
    Mismo34OtherIncomeType["Royalties"] = "Royalties";
    Mismo34OtherIncomeType["SeparateMaintenance"] = "SeparateMaintenance";
    Mismo34OtherIncomeType["SocialSecurity"] = "SocialSecurity";
    Mismo34OtherIncomeType["TemporaryLeave"] = "TemporaryLeave";
    Mismo34OtherIncomeType["TipIncome"] = "TipIncome";
    Mismo34OtherIncomeType["Trust"] = "Trust";
    Mismo34OtherIncomeType["Unemployment"] = "Unemployment";
    Mismo34OtherIncomeType["VABenefitsNonEducational"] = "VABenefitsNonEducational";
    Mismo34OtherIncomeType["Other"] = "Other";
})(Mismo34OtherIncomeType || (exports.Mismo34OtherIncomeType = Mismo34OtherIncomeType = {}));
/* ========== End of Income Item ========== */
/* ========== Start of Owned Property ========== */
var Mismo34OwnedPropertyDispositionStatusType;
(function (Mismo34OwnedPropertyDispositionStatusType) {
    Mismo34OwnedPropertyDispositionStatusType["PendingSale"] = "PendingSale";
    Mismo34OwnedPropertyDispositionStatusType["Retain"] = "Retain";
    Mismo34OwnedPropertyDispositionStatusType["Sold"] = "Sold";
})(Mismo34OwnedPropertyDispositionStatusType || (exports.Mismo34OwnedPropertyDispositionStatusType = Mismo34OwnedPropertyDispositionStatusType = {}));
var Mismo34PropertyCurrentUsageType;
(function (Mismo34PropertyCurrentUsageType) {
    Mismo34PropertyCurrentUsageType["Investment"] = "Investment";
    Mismo34PropertyCurrentUsageType["PrimaryResidence"] = "PrimaryResidence";
    Mismo34PropertyCurrentUsageType["SecondHome"] = "SecondHome";
})(Mismo34PropertyCurrentUsageType || (exports.Mismo34PropertyCurrentUsageType = Mismo34PropertyCurrentUsageType = {}));
var Mismo34PropertyIntendedUsageType;
(function (Mismo34PropertyIntendedUsageType) {
    Mismo34PropertyIntendedUsageType["Investment"] = "Investment";
    Mismo34PropertyIntendedUsageType["PrimaryResidence"] = "PrimaryResidence";
    Mismo34PropertyIntendedUsageType["SecondHome"] = "SecondHome";
    Mismo34PropertyIntendedUsageType["Other"] = "Other";
})(Mismo34PropertyIntendedUsageType || (exports.Mismo34PropertyIntendedUsageType = Mismo34PropertyIntendedUsageType = {}));
// A value from a MISMO prescribed list that specifies the type of account associated with an asset.
var Mismo34AssetAccountType;
(function (Mismo34AssetAccountType) {
    Mismo34AssetAccountType["BorrowerManagedAccount"] = "BorrowerManagedAccount";
})(Mismo34AssetAccountType || (exports.Mismo34AssetAccountType = Mismo34AssetAccountType = {}));
// A value from a MISMO prescribed list that classifies the asset (only the values we emit).
var Mismo34AssetType;
(function (Mismo34AssetType) {
    Mismo34AssetType["RealEstateOwned"] = "RealEstateOwned";
})(Mismo34AssetType || (exports.Mismo34AssetType = Mismo34AssetType = {}));
/* ========== End of Owned Property ========== */
/* ========== Start of Asset ========== */
var Mismo34FinancialAccountAssetType;
(function (Mismo34FinancialAccountAssetType) {
    Mismo34FinancialAccountAssetType["Bond"] = "Bond";
    Mismo34FinancialAccountAssetType["BridgeLoanNotDeposited"] = "BridgeLoanNotDeposited";
    Mismo34FinancialAccountAssetType["CertificateOfDepositTimeDeposit"] = "CertificateOfDepositTimeDeposit";
    Mismo34FinancialAccountAssetType["CheckingAccount"] = "CheckingAccount";
    Mismo34FinancialAccountAssetType["IndividualDevelopmentAccount"] = "IndividualDevelopmentAccount";
    Mismo34FinancialAccountAssetType["LifeInsurance"] = "LifeInsurance";
    Mismo34FinancialAccountAssetType["MoneyMarketFund"] = "MoneyMarketFund";
    Mismo34FinancialAccountAssetType["MutualFund"] = "MutualFund";
    Mismo34FinancialAccountAssetType["RetirementFund"] = "RetirementFund";
    Mismo34FinancialAccountAssetType["SavingsAccount"] = "SavingsAccount";
    Mismo34FinancialAccountAssetType["Stock"] = "Stock";
    Mismo34FinancialAccountAssetType["StockOptions"] = "StockOptions";
    Mismo34FinancialAccountAssetType["TrustAccount"] = "TrustAccount";
})(Mismo34FinancialAccountAssetType || (exports.Mismo34FinancialAccountAssetType = Mismo34FinancialAccountAssetType = {}));
var Mismo34OtherAssetType;
(function (Mismo34OtherAssetType) {
    Mismo34OtherAssetType["CashOnHand"] = "CashOnHand";
    Mismo34OtherAssetType["PendingNetSaleProceedsFromRealEstateAssets"] = "PendingNetSaleProceedsFromRealEstateAssets";
    Mismo34OtherAssetType["ProceedsFromSaleOfNonRealEstateAsset"] = "ProceedsFromSaleOfNonRealEstateAsset";
    Mismo34OtherAssetType["ProceedsFromSecuredLoan"] = "ProceedsFromSecuredLoan";
    Mismo34OtherAssetType["ProceedsFromUnsecuredLoan"] = "ProceedsFromUnsecuredLoan";
    // Other - should only appear in final MISMO xml so it is not an enum value
})(Mismo34OtherAssetType || (exports.Mismo34OtherAssetType = Mismo34OtherAssetType = {}));
/* "Other" types of "Other" assets - on MISMO, must fill AssetType with "Other" and use this enum value in "AssetTypeOtherDescription" */
var Mismo34OtherOtherAssetType;
(function (Mismo34OtherOtherAssetType) {
    Mismo34OtherOtherAssetType["OtherLiquidAsset"] = "OtherLiquidAsset";
    Mismo34OtherOtherAssetType["OtherNonLiquidAsset"] = "OtherNonLiquidAsset";
})(Mismo34OtherOtherAssetType || (exports.Mismo34OtherOtherAssetType = Mismo34OtherOtherAssetType = {}));
var Mismo34GiftOrGrantAssetType;
(function (Mismo34GiftOrGrantAssetType) {
    Mismo34GiftOrGrantAssetType["GiftOfCash"] = "GiftOfCash";
    Mismo34GiftOrGrantAssetType["GiftOfPropertyEquity"] = "GiftOfPropertyEquity";
    Mismo34GiftOrGrantAssetType["Grant"] = "Grant";
})(Mismo34GiftOrGrantAssetType || (exports.Mismo34GiftOrGrantAssetType = Mismo34GiftOrGrantAssetType = {}));
var Mismo34GiftOrGrantFundsSourceType;
(function (Mismo34GiftOrGrantFundsSourceType) {
    Mismo34GiftOrGrantFundsSourceType["CommunityNonProfit"] = "CommunityNonProfit";
    Mismo34GiftOrGrantFundsSourceType["Employer"] = "Employer";
    Mismo34GiftOrGrantFundsSourceType["FederalAgency"] = "FederalAgency";
    Mismo34GiftOrGrantFundsSourceType["Lender"] = "Lender";
    Mismo34GiftOrGrantFundsSourceType["LocalAgency"] = "LocalAgency";
    Mismo34GiftOrGrantFundsSourceType["Other"] = "Other";
    Mismo34GiftOrGrantFundsSourceType["Parent"] = "Parent";
    Mismo34GiftOrGrantFundsSourceType["Relative"] = "Relative";
    Mismo34GiftOrGrantFundsSourceType["ReligiousNonProfit"] = "ReligiousNonProfit";
    Mismo34GiftOrGrantFundsSourceType["StateAgency"] = "StateAgency";
    Mismo34GiftOrGrantFundsSourceType["UnmarriedPartner"] = "UnmarriedPartner";
    Mismo34GiftOrGrantFundsSourceType["UnrelatedFriend"] = "UnrelatedFriend";
})(Mismo34GiftOrGrantFundsSourceType || (exports.Mismo34GiftOrGrantFundsSourceType = Mismo34GiftOrGrantFundsSourceType = {}));
// TODO(william.qin) P2 gift or grant assets
exports.ACCEPTABLE_OTHER_ASSET_TYPES = [...Object.values(Mismo34FinancialAccountAssetType), ...Object.values(Mismo34OtherAssetType), ...Object.values(Mismo34OtherOtherAssetType)];
/* ========== End of Collateral ========== */
/* ========== Start of Expense ========== */
var Mismo34ExpenseType;
(function (Mismo34ExpenseType) {
    Mismo34ExpenseType["Alimony"] = "Alimony";
    Mismo34ExpenseType["ChildSupport"] = "ChildSupport";
    Mismo34ExpenseType["JobRelatedExpenses"] = "JobRelatedExpenses";
    Mismo34ExpenseType["SeparateMaintenanceExpense"] = "SeparateMaintenanceExpense";
    Mismo34ExpenseType["OtherExpense"] = "OtherExpense";
})(Mismo34ExpenseType || (exports.Mismo34ExpenseType = Mismo34ExpenseType = {}));
/* ========== End of Expense ========== */
/* ========== Start of Liability ========== */
var Mismo34NonRealEstateLiabilityType;
(function (Mismo34NonRealEstateLiabilityType) {
    Mismo34NonRealEstateLiabilityType["CollectionsJudgmentsAndLiens"] = "CollectionsJudgmentsAndLiens";
    Mismo34NonRealEstateLiabilityType["Installment"] = "Installment";
    Mismo34NonRealEstateLiabilityType["LeasePayment"] = "LeasePayment";
    Mismo34NonRealEstateLiabilityType["Open30DayChargeAccount"] = "Open30DayChargeAccount";
    Mismo34NonRealEstateLiabilityType["Revolving"] = "Revolving";
    Mismo34NonRealEstateLiabilityType["Taxes"] = "Taxes";
    Mismo34NonRealEstateLiabilityType["TaxLien"] = "TaxLien";
    Mismo34NonRealEstateLiabilityType["Other"] = "Other";
})(Mismo34NonRealEstateLiabilityType || (exports.Mismo34NonRealEstateLiabilityType = Mismo34NonRealEstateLiabilityType = {}));
var Mismo34RealEstateLiabilityType;
(function (Mismo34RealEstateLiabilityType) {
    Mismo34RealEstateLiabilityType["HELOC"] = "HELOC";
    Mismo34RealEstateLiabilityType["MortgageLoan"] = "MortgageLoan";
})(Mismo34RealEstateLiabilityType || (exports.Mismo34RealEstateLiabilityType = Mismo34RealEstateLiabilityType = {}));
/* ========== End of Liability ========== */
/* ========== Start of Declaration ========== */
var Mismo34DeclarationYesNoUnknown;
(function (Mismo34DeclarationYesNoUnknown) {
    Mismo34DeclarationYesNoUnknown["Yes"] = "Yes";
    Mismo34DeclarationYesNoUnknown["No"] = "No";
    Mismo34DeclarationYesNoUnknown["Unknown"] = "Unknown";
})(Mismo34DeclarationYesNoUnknown || (exports.Mismo34DeclarationYesNoUnknown = Mismo34DeclarationYesNoUnknown = {}));
var Mismo34DeclarationPriorPropertyTitleType;
(function (Mismo34DeclarationPriorPropertyTitleType) {
    Mismo34DeclarationPriorPropertyTitleType["JointWithOtherThanSpouse"] = "JointWithOtherThanSpouse";
    Mismo34DeclarationPriorPropertyTitleType["JointWithSpouse"] = "JointWithSpouse";
    Mismo34DeclarationPriorPropertyTitleType["Sole"] = "Sole";
})(Mismo34DeclarationPriorPropertyTitleType || (exports.Mismo34DeclarationPriorPropertyTitleType = Mismo34DeclarationPriorPropertyTitleType = {}));
var Mismo34BankruptcyType;
(function (Mismo34BankruptcyType) {
    Mismo34BankruptcyType["ChapterEleven"] = "ChapterEleven";
    Mismo34BankruptcyType["ChapterSeven"] = "ChapterSeven";
    Mismo34BankruptcyType["ChapterThirteen"] = "ChapterThirteen";
    Mismo34BankruptcyType["ChapterTwelve"] = "ChapterTwelve";
})(Mismo34BankruptcyType || (exports.Mismo34BankruptcyType = Mismo34BankruptcyType = {}));
/* ========== End of Declaration ========== */
/* ========== Start of HMDA ========== */
var Mismo34HmdaEthnicityType;
(function (Mismo34HmdaEthnicityType) {
    Mismo34HmdaEthnicityType["HispanicOrLatino"] = "HispanicOrLatino";
    Mismo34HmdaEthnicityType["NotHispanicOrLatino"] = "NotHispanicOrLatino";
})(Mismo34HmdaEthnicityType || (exports.Mismo34HmdaEthnicityType = Mismo34HmdaEthnicityType = {}));
var Mismo34HmdaEthnicityOriginType;
(function (Mismo34HmdaEthnicityOriginType) {
    Mismo34HmdaEthnicityOriginType["Cuban"] = "Cuban";
    Mismo34HmdaEthnicityOriginType["Mexican"] = "Mexican";
    Mismo34HmdaEthnicityOriginType["Other"] = "Other";
    Mismo34HmdaEthnicityOriginType["PuertoRican"] = "PuertoRican";
})(Mismo34HmdaEthnicityOriginType || (exports.Mismo34HmdaEthnicityOriginType = Mismo34HmdaEthnicityOriginType = {}));
var Mismo34HmdaGenderType;
(function (Mismo34HmdaGenderType) {
    Mismo34HmdaGenderType["ApplicantSelectedBothMaleAndFemale"] = "ApplicantSelectedBothMaleAndFemale";
    Mismo34HmdaGenderType["Female"] = "Female";
    Mismo34HmdaGenderType["Male"] = "Male";
})(Mismo34HmdaGenderType || (exports.Mismo34HmdaGenderType = Mismo34HmdaGenderType = {}));
var Mismo34HmdaRaceType;
(function (Mismo34HmdaRaceType) {
    Mismo34HmdaRaceType["AmericanIndianOrAlaskaNative"] = "AmericanIndianOrAlaskaNative";
    Mismo34HmdaRaceType["Asian"] = "Asian";
    Mismo34HmdaRaceType["BlackOrAfricanAmerican"] = "BlackOrAfricanAmerican";
    Mismo34HmdaRaceType["NativeHawaiianOrOtherPacificIslander"] = "NativeHawaiianOrOtherPacificIslander";
    Mismo34HmdaRaceType["White"] = "White";
})(Mismo34HmdaRaceType || (exports.Mismo34HmdaRaceType = Mismo34HmdaRaceType = {}));
var Mismo34HmdaRaceDesignationType;
(function (Mismo34HmdaRaceDesignationType) {
    Mismo34HmdaRaceDesignationType["AsianIndian"] = "AsianIndian";
    Mismo34HmdaRaceDesignationType["Chinese"] = "Chinese";
    Mismo34HmdaRaceDesignationType["Filipino"] = "Filipino";
    Mismo34HmdaRaceDesignationType["GuamanianOrChamorro"] = "GuamanianOrChamorro";
    Mismo34HmdaRaceDesignationType["Japanese"] = "Japanese";
    Mismo34HmdaRaceDesignationType["Korean"] = "Korean";
    Mismo34HmdaRaceDesignationType["NativeHawaiian"] = "NativeHawaiian";
    Mismo34HmdaRaceDesignationType["OtherAsian"] = "OtherAsian";
    Mismo34HmdaRaceDesignationType["OtherPacificIslander"] = "OtherPacificIslander";
    Mismo34HmdaRaceDesignationType["Samoan"] = "Samoan";
    Mismo34HmdaRaceDesignationType["Vietnamese"] = "Vietnamese";
})(Mismo34HmdaRaceDesignationType || (exports.Mismo34HmdaRaceDesignationType = Mismo34HmdaRaceDesignationType = {}));
var Mismo34HmdaApplicationTakenType;
(function (Mismo34HmdaApplicationTakenType) {
    // Email = "Email",
    // FaceToFace = "FaceToFace",
    // Fax = "Fax",
    Mismo34HmdaApplicationTakenType["Internet"] = "Internet";
    // Mail = "Mail",
    // Telephone = "Telephone",
})(Mismo34HmdaApplicationTakenType || (exports.Mismo34HmdaApplicationTakenType = Mismo34HmdaApplicationTakenType = {}));
/* ========== End of HMDA ========== */
/* ========== Start of Credit ========== */
// A value from a MISMO prescribed list that specifies the credit repository that sourced the score.
var Mismo34CreditRepositorySourceType;
(function (Mismo34CreditRepositorySourceType) {
    Mismo34CreditRepositorySourceType["Equifax"] = "Equifax";
    Mismo34CreditRepositorySourceType["Experian"] = "Experian";
    Mismo34CreditRepositorySourceType["TransUnion"] = "TransUnion";
})(Mismo34CreditRepositorySourceType || (exports.Mismo34CreditRepositorySourceType = Mismo34CreditRepositorySourceType = {}));
// A value from a MISMO prescribed list that specifies the category of the loan-level credit score.
var Mismo34CreditScoreCategoryType;
(function (Mismo34CreditScoreCategoryType) {
    Mismo34CreditScoreCategoryType["FICO"] = "FICO";
    Mismo34CreditScoreCategoryType["Vantage"] = "Vantage";
})(Mismo34CreditScoreCategoryType || (exports.Mismo34CreditScoreCategoryType = Mismo34CreditScoreCategoryType = {}));
/* ========== End of Credit ========== */
/* ========== Start of Party ========== */
var Mismo34PartyRoleType;
(function (Mismo34PartyRoleType) {
    // SubmittingParty = 'SubmittingParty',
    Mismo34PartyRoleType["Borrower"] = "Borrower";
    Mismo34PartyRoleType["Cosigner"] = "Cosigner";
    // NotePayTo = 'NotePayTo',
    Mismo34PartyRoleType["Lender"] = "Lender";
    Mismo34PartyRoleType["LoanOriginationCompany"] = "LoanOriginationCompany";
    Mismo34PartyRoleType["LoanOriginator"] = "LoanOriginator";
    Mismo34PartyRoleType["MortgageBroker"] = "MortgageBroker";
    Mismo34PartyRoleType["PropertyOwner"] = "PropertyOwner";
    Mismo34PartyRoleType["TitleHolder"] = "TitleHolder";
    Mismo34PartyRoleType["Trust"] = "Trust";
    // HousingCounselingAgency = 'HousingCounselingAgency',
})(Mismo34PartyRoleType || (exports.Mismo34PartyRoleType = Mismo34PartyRoleType = {}));
// A value from a MISMO prescribed list that specifies the type of loan originator.
var Mismo34LoanOriginatorType;
(function (Mismo34LoanOriginatorType) {
    Mismo34LoanOriginatorType["Broker"] = "Broker";
    Mismo34LoanOriginatorType["Lender"] = "Lender";
})(Mismo34LoanOriginatorType || (exports.Mismo34LoanOriginatorType = Mismo34LoanOriginatorType = {}));
// A value from a MISMO prescribed list that specifies the governmental level of the license authority.
var Mismo34LicenseAuthorityLevelType;
(function (Mismo34LicenseAuthorityLevelType) {
    Mismo34LicenseAuthorityLevelType["Private"] = "Private";
    Mismo34LicenseAuthorityLevelType["PublicState"] = "PublicState";
})(Mismo34LicenseAuthorityLevelType || (exports.Mismo34LicenseAuthorityLevelType = Mismo34LicenseAuthorityLevelType = {}));
var Mismo34TaxpayerIdentifierType;
(function (Mismo34TaxpayerIdentifierType) {
    // IndividualTaxpayerIdentificationNumber = 'IndividualTaxpayerIdentificationNumber',
    Mismo34TaxpayerIdentifierType["SocialSecurityNumber"] = "SocialSecurityNumber";
    Mismo34TaxpayerIdentifierType["EmployerIdentificationNumber"] = "EmployerIdentificationNumber";
})(Mismo34TaxpayerIdentifierType || (exports.Mismo34TaxpayerIdentifierType = Mismo34TaxpayerIdentifierType = {}));
var Mismo34MaritalStatusType;
(function (Mismo34MaritalStatusType) {
    Mismo34MaritalStatusType["Married"] = "Married";
    Mismo34MaritalStatusType["Separated"] = "Separated";
    Mismo34MaritalStatusType["Unmarried"] = "Unmarried";
})(Mismo34MaritalStatusType || (exports.Mismo34MaritalStatusType = Mismo34MaritalStatusType = {}));
var Mismo34ContactPointRoleType;
(function (Mismo34ContactPointRoleType) {
    Mismo34ContactPointRoleType["Home"] = "Home";
    Mismo34ContactPointRoleType["Mobile"] = "Mobile";
    Mismo34ContactPointRoleType["Work"] = "Work";
})(Mismo34ContactPointRoleType || (exports.Mismo34ContactPointRoleType = Mismo34ContactPointRoleType = {}));
var Mismo34CitizenshipResidencyType;
(function (Mismo34CitizenshipResidencyType) {
    Mismo34CitizenshipResidencyType["NonPermanentResidentAlien"] = "NonPermanentResidentAlien";
    Mismo34CitizenshipResidencyType["PermanentResidentAlien"] = "PermanentResidentAlien";
    Mismo34CitizenshipResidencyType["USCitizen"] = "USCitizen";
})(Mismo34CitizenshipResidencyType || (exports.Mismo34CitizenshipResidencyType = Mismo34CitizenshipResidencyType = {}));
/* ========== End of Party ========== */
var Mismo34RelationshipArcrole;
(function (Mismo34RelationshipArcrole) {
    Mismo34RelationshipArcrole["CurrentIncomeItemIsAssociatedWithEmployer"] = "urn:fdc:mismo.org:2009:residential/CURRENT_INCOME_ITEM_IsAssociatedWith_EMPLOYER";
})(Mismo34RelationshipArcrole || (exports.Mismo34RelationshipArcrole = Mismo34RelationshipArcrole = {}));
